module.exports = __webpack_public_path__ + "static/selected.daa49e4b.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/selected.png
// module id = 1035
// module chunks = 2